import { useTranslation } from 'react-i18next';
import { PageMeta } from '../components/PageMeta';

type ValueItem = {
  title: string;
  body: string;
};

export function AboutPage() {
  const { t } = useTranslation();
  const intro = t('aboutPage.intro', { returnObjects: true }) as string[];
  const mission = t('aboutPage.mission', { returnObjects: true }) as string[];
  const values = t('aboutPage.values', { returnObjects: true }) as ValueItem[];

  return (
    <>
      <PageMeta titleKey="aboutPage.metaTitle" descriptionKey="aboutPage.metaDescription" />

      <section className="section-band section-band--dark-mid about-hero">
        <div className="about-hero-inner">
          <p className="about-eyebrow">{t('aboutPage.eyebrow')}</p>
          <h1>{t('aboutPage.title')}</h1>
          <p className="about-tagline">{t('aboutPage.tagline')}</p>
        </div>
      </section>

      <section className="about-section" aria-labelledby="about-intro-heading">
        <div className="about-section-inner">
          <h2 id="about-intro-heading">{t('aboutPage.aboutHeading')}</h2>
          {intro.map((paragraph) => (
            <p key={paragraph.slice(0, 48)}>{paragraph}</p>
          ))}
        </div>
      </section>

      <section
        className="about-section about-section--alt"
        aria-labelledby="about-mission-heading"
      >
        <div className="about-section-inner">
          <h2 id="about-mission-heading">{t('aboutPage.missionHeading')}</h2>
          {mission.map((paragraph) => (
            <p key={paragraph.slice(0, 48)}>{paragraph}</p>
          ))}
        </div>
      </section>

      <section className="about-section" aria-labelledby="about-values-heading">
        <div className="about-section-inner">
          <h2 id="about-values-heading">{t('aboutPage.valuesHeading')}</h2>
          <ul className="values-grid">
            {values.map((value) => (
              <li key={value.title} className="value-card">
                <h3>{value.title}</h3>
                <p>{value.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}
